import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminCampaignsKeys } from "Api/Queries/Admin/useAdminCampaignsQuery";
import {
  type UpdateCampaignRequest,
  type UpdateCampaignCommandResult,
  putAdminCampaignsId,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = { id: number; data: UpdateCampaignRequest };

type Props = {
  onSuccess?: (result: UpdateCampaignCommandResult) => void;
  onError?: (error: Error) => void;
};

export const useUpdateCampaignMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation<UpdateCampaignCommandResult, Error, Parameters>({
    mutationFn: processResponseWithApiProblemDetails(
      ({ id, data }: Parameters) => putAdminCampaignsId(data, id),
    ),
    onSuccess: (result, parameters) => {
      queryClient.invalidateQueries({
        queryKey: adminCampaignsKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: adminCampaignsKeys.detail(parameters.id),
      });
      onSuccess?.(result);
    },
    onError,
  });
};
